// extracted by mini-css-extract-plugin
export default {"editButton":"style_editButton__Z2ty6","icon":"style_icon__2pXrF"};